import { useState } from "react";
import RadioButtonGroup from "../Input/RadioButtonGroup";
import { useTranslation } from "react-i18next";
import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";
import usePaymentHook from "@/shared/hooks/usePaymentHook";

const ChangeOfflinePaymentModal = (props) => {
  const { t } = useTranslation();
  const [{ defaultPayment, orderId, sessionId, refetchOrder, updateFn }] =
    useModalMeta();
  const setModal = useSetModal();
  const [payment, setPayment] = useState<number>(defaultPayment);
  const { offlinePayments } = usePaymentHook();

  return (
    <Modal onExit={() => setModal("")} {...props}>
      <RadioButtonGroup
        label={t("order.changePaymentMethod")}
        onChange={(e) => setPayment(Number(e.target.value))}
        value={payment}
        options={offlinePayments.map((payment) => ({
          value: payment.value,
          label: t(`${payment.translationKey}`),
        }))}
      />
      <Button
        onClick={() =>
          updateFn.mutateAsync(
            {
              id: sessionId ? sessionId : orderId,
              paymentMethodId: payment,
            },
            {
              onSuccess: () => {
                setModal("", {});
                refetchOrder();
              },
            }
          )
        }
        isPending={updateFn.isPending}
      >
        {t("save")}
      </Button>
    </Modal>
  );
};

export default ChangeOfflinePaymentModal;
